"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassifyModalContext = void 0;
const react_1 = __importDefault(require("react"));
const predicate_language_1 = require("@groupby/predicate-language");
exports.ClassifyModalContext = react_1.default.createContext({
    activeTab: 0,
    searchFilter: new predicate_language_1.PredicateBuilder(),
});
